import { Skeleton } from 'antd';
import { MouseEventHandler } from 'react';

import pdfIcon from '@/assets/file-icons/pdf.png';
import { downloadFile } from '@/utils/download-file';

import { useInvoicePdf } from '../api/use-invoice-saf-pdf';

type Props = {
  invoiceNo: string;
};

const DownloadInvoiceButton = ({ invoiceNo }: Props) => {
  const invoiceDownloadQuery = useInvoicePdf({ invoiceNo, queryConfig: { enabled: false } });

  const handleDownload: MouseEventHandler<HTMLButtonElement> = async (event) => {
    event.stopPropagation();

    const {
      data: { data: blob },
    } = await invoiceDownloadQuery.refetch();
    downloadFile(blob, `${invoiceNo}.pdf`);
  };

  if (invoiceDownloadQuery.isLoading) {
    return <Skeleton.Node active className="w-6 h-6" />;
  }

  return (
    <button onClick={handleDownload}>
      <img src={pdfIcon} alt="pdf-icon" width={24} height={24} />
    </button>
  );
};

export default DownloadInvoiceButton;
